
<p-card header="Date Settings">
    <label for="selectedStartDate">Start Date</label>
    <div class="field">
        <p-calendar [(ngModel)]="selectedStartDate" [showClear]="true" inputId="selectedStartDate"></p-calendar>
    </div>
    <label for="selectedEndDate">End Date</label>
    <div class="field">
        <p-calendar [(ngModel)]="selectedEndDate" [showClear]="true" inputId="selectedEndDate"></p-calendar>
    </div>
    <div class="field-checkbox">
        <p-checkbox [(ngModel)]="usePastWeek" [binary]="true" inputId="usePastWeek"></p-checkbox>
        <label for="usePastWeek">Use Recent Data (1 week for list pages, 1 day for graphs)</label>
    </div>
    <br>
    <div class="field">
        <p-button (onClick)="save($event)" label="Save"></p-button>
    </div>
</p-card>
<br>
<p-card header="Notification Settings">
    <p-button [disabled]="isSubscribed" (click)="subscribeToNotifications()" label="Subscribe to Notifications"></p-button>
    <br>
    <br>
    <div class="grid">
        <div class="col-12">
            <p-panel>
                <ng-template pTemplate="header">
                    <label>Incidents</label>
                </ng-template>
                <div class="field-checkbox">
                    <p-checkbox [disabled]="!isSubscribed" [(ngModel)]="newIncidents" [binary]="true" inputId="newIncidents"></p-checkbox>
                    <label for="newIncidents">New Incidents (not implemented yet)</label>
                </div>
                <div class="field-checkbox">
                    <p-checkbox [disabled]="!isSubscribed" [(ngModel)]="updatedIncidents" [binary]="true" inputId="updatedIncidents"></p-checkbox>
                    <label for="updatedIncidents">Updated Incidents (not implemented yet)</label>
                </div>
            </p-panel>
        </div>
        <div class="col-12">
            <p-panel>
                <ng-template pTemplate="header">
                    <label>Instruments</label>
                </ng-template>
                <div class="field-checkbox">
                    <p-checkbox [disabled]="!isSubscribed" [(ngModel)]="instrumentInService" [binary]="true" inputId="instrumentInService"></p-checkbox>
                    <label for="instrumentInService">Instrument Put Into Service</label>
                </div>
                <div class="field-checkbox">
                    <p-checkbox [disabled]="!isSubscribed" [(ngModel)]="instrumentOutOfService" [binary]="true" inputId="instrumentOutOfService"></p-checkbox>
                    <label for="instrumentOutOfService">Instrument Taken Out Of Service</label>
                </div>
                <div class="field-checkbox">
                    <p-checkbox [disabled]="!isSubscribed" [(ngModel)]="instrumentLowCount" [binary]="true" inputId="instrumentLowCount"></p-checkbox>
                    <label for="instrumentLowCount">Instrument Active Count below 80% (not implemented yet)</label>
                </div>
            </p-panel>
        </div>
        <div class="col-12">
            <p-panel>
                <ng-template pTemplate="header">
                    <label>Sensors</label>
                </ng-template>
                <div *ngFor="let sensor of sensors; let i = index">
                    <div class="field-checkbox">
                        <p-checkbox [disabled]="!isSubscribed" [(ngModel)]="sensor.notifEnabled" [binary]="true" [inputId]="sensor.id"></p-checkbox>
                        <label for="group_{{i}}">{{sensor.name}} (not implemented yet)</label>
                    </div>
                </div>
            </p-panel>
        </div>
        <div class="col-12">
            <p-panel>
                <ng-template pTemplate="header">
                    <label>Plates</label>
                </ng-template>
                <div class="field-checkbox">
                    <p-checkbox [disabled]="!isSubscribed" [(ngModel)]="plateCompletions" [binary]="true" inputId="plateCompletions"></p-checkbox>
                    <label for="plateCompletions">Track Plate Completions (not implemented yet)</label>
                </div>
                <div class="flex-auto">
                    <label htmlFor="platesToMonitor">Comma Delimited List of Plates</label>
                    <input [disabled]="!isSubscribed || !plateCompletions" type="text" pInputText [(ngModel)]="platesToMonitor" inputId="platesToMonitor"/>
                </div>
            </p-panel>
        </div>
        <div class="col-12">
            <p-panel>
                <ng-template pTemplate="header">
                    <label for="isoAlerts">QA/QC</label>
                </ng-template>
                <div class="field-checkbox">
                    <p-checkbox [disabled]="!isSubscribed" [(ngModel)]="isoAlerts" [binary]="true" inputId="isoAlerts"></p-checkbox>
                    <label for="isoAlerts">Iso (not implemented yet)</label>
                </div>
                <div class="field-checkbox">
                    <p-checkbox [disabled]="!isSubscribed" [(ngModel)]="splitCjunEnabled" [binary]="true" inputId="splitCjunEnabled"></p-checkbox>
                    <label for="splitCjunEnabled">Split Cjun (not implemented yet)</label>
                </div>
                <div class="flex-auto">
                    <label for="splitCjunHours" class="mr-1">Window to track (hours)</label>
                    <p-inputNumber [disabled]="!isSubscribed || !splitCjunEnabled" type="number" [(ngModel)]="splitCjunHours" inputId="splitCjunHours"></p-inputNumber>
                </div>
                <div class="flex-auto">
                    <label htmlFor="splitCjunCT" class="mr-1">CT to track</label>
                    <p-inputNumber [disabled]="!isSubscribed || !splitCjunEnabled" type="number" [(ngModel)]="splitCjunCT" inputId="splitCjunCT"></p-inputNumber>
                </div>
                <div class="flex-auto">
                    <label htmlFor="splitCjunAmount" class="mr-1">Amount of wells</label>
                    <p-inputNumber [disabled]="!isSubscribed || !splitCjunEnabled" type="number" [(ngModel)]="splitCjunAmount" inputId="splitCjunAmount"></p-inputNumber>
                </div>
            </p-panel>
        </div>
    </div>
    <br>
    <div class="field">
        <p-button (onClick)="save($event)" label="Save"></p-button>
    </div>
</p-card>